import { render, staticRenderFns } from "./Testi.vue?vue&type=template&id=c11be8e8&"
import script from "./Testi.vue?vue&type=script&lang=js&"
export * from "./Testi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports